var _defs, _path, _path2, _circle, _circle2, _circle3, _circle4, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightRainSnow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-7d5cd071-89af-4141-8dbc-c98d276c3530",
    "data-name": "uuid-725af453-7f27-40bb-a05f-8571105dd0d8",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1078.1 1078.07",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "uuid-2ad2def5-7997-4ef6-bb88-af65353c70e1",
    d: "M804.04,89.83c-9.03,0-17.91.8-26.76,1.68C724.67,34.79,649.79-.97,566.51-.97c-102.48,0-192.36,53.99-243.37,134.85-21.43-5.86-43.72-9.17-66.52-9.17C117.31,124.72,3.96,238.1,3.96,377.41s113.35,252.64,252.66,252.64h28.27l-99.07,163.45c-5.35,8.81-2.53,20.29,6.3,25.64,3.02,1.85,6.37,2.72,9.66,2.72,6.33,0,12.48-3.21,16.01-9l110.82-182.81h226.12l-209.96,361.11c-5.18,8.9-2.17,20.34,6.76,25.55,2.94,1.7,6.18,2.53,9.37,2.53,6.45,0,12.7-3.31,16.18-9.29l220.89-379.89h191.57l-129.65,228.41c-5.08,9-1.95,20.39,7.03,25.5,2.92,1.65,6.08,2.43,9.2,2.43,6.52,0,12.82-3.41,16.28-9.44l141.11-248.58c135.11-14.74,240.64-129.44,240.64-268.42,0-148.95-121.16-270.11-270.11-270.11ZM804.04,592.68H256.62c-118.7,0-215.29-96.59-215.29-215.27s96.59-215.32,215.29-215.32c16.42,0,32.53,2.08,48.18,5.67,12.49,2.87,24.57,6.93,36.28,11.92,37.55,16.05,70.47,42.41,94.09,77.34,5.77,8.56,17.35,10.85,25.94,5.01,8.54-5.79,10.8-17.37,5.01-25.94-27.01-39.97-64.46-70.3-107.17-89.27,45.05-66.58,121.27-110.43,207.56-110.43,63.48,0,120.84,24.49,165.03,63.54-62.87,17.44-118.02,57.06-154.54,113.58-5.6,8.66-3.11,20.19,5.55,25.79,8.66,5.64,20.22,3.16,25.84-5.55,35.25-54.53,90.7-90.68,153.06-102.22,13.94-2.58,28.1-4.34,42.6-4.34.64,0,1.24.18,1.89.19,127.45,1.04,230.85,104.87,230.85,232.54s-104.4,232.74-232.74,232.74Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "uuid-2ad2def5-7997-4ef6-bb88-af65353c70e1",
    d: "M355.95,739.65c-8.86-5.37-20.32-2.49-25.62,6.43l-182.97,304.66c-5.32,8.82-2.46,20.32,6.4,25.64,2.96,1.77,6.23,2.63,9.44,2.65,6.4.05,12.65-3.17,16.17-9.08l182.97-304.66c5.32-8.82,2.46-20.32-6.4-25.64Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "uuid-2ad2def5-7997-4ef6-bb88-af65353c70e1",
    cx: 53.54,
    cy: 654.72,
    r: 33.73
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "uuid-2ad2def5-7997-4ef6-bb88-af65353c70e1",
    cx: 75.06,
    cy: 858.29,
    r: 33.73
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "uuid-2ad2def5-7997-4ef6-bb88-af65353c70e1",
    cx: 678.93,
    cy: 941.75,
    r: 33.73
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "uuid-2ad2def5-7997-4ef6-bb88-af65353c70e1",
    cx: 877.79,
    cy: 858.29,
    r: 33.73
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "uuid-2ad2def5-7997-4ef6-bb88-af65353c70e1",
    d: "M956.16,661.63c-18.63,0-33.74,15.1-33.74,33.73s15.11,33.73,33.74,33.73,33.73-15.1,33.73-33.73-15.1-33.73-33.73-33.73Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightRainSnow);
export default __webpack_public_path__ + "static/media/LightRainSnow.5f6537b02aa76136d058be6cb4dbb691.svg";
export { ForwardRef as ReactComponent };